import { render, staticRenderFns } from "./SeriesAwards.vue?vue&type=template&id=1d19ef8a&scoped=true&"
import script from "./SeriesAwards.vue?vue&type=script&lang=js&"
export * from "./SeriesAwards.vue?vue&type=script&lang=js&"
import style0 from "./SeriesAwards.vue?vue&type=style&index=0&id=1d19ef8a&prod&lang=scss&"
import style1 from "./SeriesAwards.vue?vue&type=style&index=1&id=1d19ef8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d19ef8a",
  null
  
)

export default component.exports